export default __webpack_public_path__ + "static/media/Pharmacy.de07c721.png";